import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

export const ReadExampleDemandLetterBadge = ({
  isDone,
  ...props
}: BaseToolBadgeProps) => {
  const allProps = { ...props, isDone };

  return (
    <BaseBadge
      {...allProps}
      showArgs={false}
      resultTexts={{
        loading: 'Reading example demand letter...',
        done: `Read example demand letter  `,
        error: 'Error reading example demand letter',
      }}
    />
  );
};
